// @flow
import type { ScriptCommonArgs } from '../../types';

import analyticsEvents from "./analyticsEvents";
import facebookSdk from './facebookSdk';
import { localeSelect } from './localeSelect';
import privacySettings from './privacySettings';
import sendNickname from './sendNickname';
import showSubscribers from './showSubscribers';
import thankYouModal from './thankYouModal';
import twitter from './twitter';

export default (props: ScriptCommonArgs) => {
  twitter(props);
  facebookSdk(props);
  thankYouModal(props);
  sendNickname(props);
  showSubscribers(props);
  privacySettings();
  localeSelect(props);
  analyticsEvents(props);
};
